import React from 'react';
import PropTypes from 'prop-types';
import FontIcon from '../FontIcon';
import './LockIcon.css';

function LockIcon({ className, size, title, alt, filled, disabled }) {
  return (
    <FontIcon
      icon="lock"
      className={`lock-icon ${className || ''} ${size || ''}`}
      title={title}
      alt={alt}
      filled={filled}
      disabled={disabled}
    />
  );
}

LockIcon.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  alt: PropTypes.string.isRequired,
  filled: PropTypes.bool,
  disabled: PropTypes.bool
};

export default LockIcon;
